module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f56033dd9db0150762c6acb792816ac9.png";